





















import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoTopBar from '@/main/respondeco-top-bar.vue'
import { Prop } from 'vue-property-decorator'
import UnifyButton from '@/shared/components/unify/unify-button.vue'

@Component({
  components: { UnifyButton, RespondecoTopBar },
})
export default class RespondecoSaveBar extends Vue {
  @Prop({
    required: true,
    type: Boolean,
  })
  public readonly dirty!: boolean

  @Prop({
    required: true,
    type: Boolean,
  })
  public readonly invalid!: boolean

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly loading!: boolean

  public reset() {
    this.$emit('reset')
  }

  public submit() {
    this.$emit('submit')
  }
}
